import { mergeAttributes, Node } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import ChromeNodeViewComponent from '@/views/components/atoms/tiptap/Extensions/ChromeNodeViewComponent.vue';

export default Node.create({
  name: 'draggableItem',

  group: 'block',

  content: 'block+',

  draggable: true,

  parseHTML() {
    return [
      {
        tag: 'div[data-type="draggable-item"]',
      },
    ]
  },

  addAttributes() {
    return {
      'data-attributes': {
        default: {},
        parseHTML: element => {
          const dataAttributes = {};
          Array.from(element.attributes).forEach(attr => {
            if (attr.name.startsWith('data-')) {
              dataAttributes[attr.name] = attr.value;
            }
          });
          return dataAttributes;
        },
        renderHTML: attributes => {
          return attributes['data-attributes'] || {};
        },
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    const dataAttributes = HTMLAttributes['data-attributes'] || {};

    return [
      'div',
      mergeAttributes(HTMLAttributes, { 'data-type': 'draggable-item' }),
      0, // Allow children and their data-* attributes to persist
    ];
  },

  addNodeView() {
    return VueNodeViewRenderer(ChromeNodeViewComponent)
  },
})
